import keyMirror from 'keymirror';
import extra_optionsIcon from '../../images/illustrations/icons/extraOptions.svg';
import couchIcon from '../../images/illustrations/methods/couch.svg';
import shoeboxesIcon from '../../images/illustrations/methods/shoeboxes.svg';
import typingIcon from '../../images/illustrations/methods/typing.svg';
import jetpackIcon from '../../images/illustrations/rectangular/jetpack.svg';
import teacherIcon from '../../images/illustrations/rectangular/teacher.svg';
import bookIcon from '../../images/illustrations/supporting/book.svg';
import cuttingIcon from '../../images/illustrations/supporting/cutting.svg';
import groupIcon from '../../images/illustrations/supporting/group.svg';
import practice_methodsIcon from '../../images/illustrations/supporting/practiceMethods.svg';
import qna_singleIcon from '../../images/illustrations/supporting/qnaSingle.svg';
import practice_per_topicIcon from '../../images/illustrations/supporting/practicePerTopic.svg';
import astronautIcon from '../../images/illustrations/supporting/astronaut.svg';
import pointer_test_standingIcon from '../../images/illustrations/supporting/pointerTestStanding.svg';
import video_tutoringIcon from '../../images/illustrations/supporting/videoTutoring.svg';
import { BRAND_NAME } from '../../services/Constants';

export const listsActionTypes = keyMirror({
	GET_RECENT_LISTS_REQUEST: null,
	GET_RECENT_LISTS_SUCCESS: null,
	GET_RECENT_LISTS_ERROR: null,

	GET_RECENT_ITEMS_REQUEST: null,
	GET_RECENT_ITEMS_SUCCESS: null,
	GET_RECENT_ITEMS_ERROR: null,

	GET_MADE_LISTS_REQUEST: null,
	GET_MADE_LISTS_SUCCESS: null,
	GET_MADE_LISTS_ERROR: null,

	GET_FOLDERS_REQUEST: null,
	GET_FOLDERS_SUCCESS: null,
	GET_FOLDERS_ERROR: null,

	GET_RECENT_LESSONS_REQUEST: null,
	GET_RECENT_LESSONS_SUCCESS: null,
	GET_RECENT_LESSONS_ERROR: null,

	CREATE_FOLDER_REQUEST: null,
	CREATE_FOLDER_SUCCESS: null,
	CREATE_FOLDER_ERROR: null,

	RESEND_EMAIL_VERIFICATION_REQUEST: null,
	RESEND_EMAIL_VERIFICATION_SUCCESS: null,
	RESEND_EMAIL_VERIFICATION_ERROR: null,

	CONFIRM_EMAIL_REQUEST: null,
	CONFIRM_EMAIL_SUCCESS: null,
	CONFIRM_EMAIL_ERROR: null,

	SET_LOADING: null,
	CLEAN_LISTS_STATE: null,
	CLEAN_MADE_LIST_STATE: null,
	HIDE_ONBOARDING_TASKS_REQUEST: null,

	HIDE_RECENT_ITEM_REQUEST: null,
	HIDE_RECENT_ITEM_SUCCESS: null,
});

export const getSortingOptions = (t, withoutLanguage) => {
	const options = [
		{ title: t('lists.sorting_options.last_modified'), key: 'last_updated_at_timestamp' },
		{ title: t('lists.sorting_options.last_practiced'), key: 'last_practiced_timestamp' },
		{ title: t('lists.sorting_options.alphabetically'), key: 'alphabetical' },
	];

	if (!withoutLanguage)
		options.push({ title: t('lists.sorting_options.language'), key: 'language' });

	return options;
};

export const getListTabs = (t) => [
	{ title: t('lists.tabs.recent'), value: 'recent', index: 0, link: 'recent' },
	{ title: t('lists.tabs.created'), value: 'created', index: 1, link: 'created' },
	{ title: t('lists.tabs.subjects'), value: 'subjects', index: 2, link: 'subjects' },
	{ title: t('lists.tabs.folders'), value: 'folders', index: 3, link: 'folders' },
];

export const getRecentEmptyStateInfo = (t, status) => {
	switch (status) {
		case 'school-student':
			return {
				title: t('recent_lists.empty_state.school_student.title'),
				description: t('recent_lists.empty_state.school_student.description', {
					brandName: BRAND_NAME,
				}),
				image: jetpackIcon,
				btnTitle: t('recent_lists.empty_state.school_student.btnTitle'),
				onClick: 'selectSubject',
				hideIcon: true,
				extraBtnIcon: 'add',
				extraBtnTitle: t('recent_lists.empty_state.school_student.extraBtnTitle'),
				extraBtnOnClick: 'createList',
				showExtraBtn: false,
			};
		case 'non-school-student':
			return {
				title: t('recent_lists.empty_state.non_school_student.title'),
				description: t('recent_lists.empty_state.non_school_student.description'),
				image: jetpackIcon,
				btnTitle: t('recent_lists.empty_state.non_school_student.btnTitle'),
				onClick: undefined,
				hideIcon: false,
				extraBtnIcon: 'search',
				extraBtnTitle: t('recent_lists.empty_state.non_school_student.extraBtnTitle'),
				extraBtnOnClick: 'searchBook',
				showExtraBtn: true,
			};

		case 'school-teacher':
			return {
				title: t('recent_lists.empty_state.school_teacher.title'),
				description: t('recent_lists.empty_state.school_teacher.description_2'),
				image: teacherIcon,
				btnTitle: t('recent_lists.empty_state.school_teacher.btnTitle'),
				onClick: 'createGroup',
				hideIcon: false,
				extraBtnIcon: 'add',
				extraBtnTitle: t('recent_lists.empty_state.school_teacher.extraBtnTitle'),
				extraBtnOnClick: 'selectSubject',
				showExtraBtn: true,
			};

		case 'non-school-teacher':
			return {
				title: t('recent_lists.empty_state.non_school_teacher.title'),
				description: t('recent_lists.empty_state.non_school_teacher.description_2'),
				image: teacherIcon,
				btnTitle: t('recent_lists.empty_state.non_school_teacher.btnTitle'),
				onClick: 'createGroup',
				hideIcon: false,
				extraBtnIcon: 'search',
				extraBtnTitle: t('recent_lists.empty_state.non_school_teacher.extraBtnTitle'),
				extraBtnOnClick: 'searchBook',
				showExtraBtn: true,
			};

		default:
			break;
	}
};

const onboardingImages = {
	bookIcon,
	couchIcon,
	cuttingIcon,
	extra_optionsIcon,
	groupIcon,
	practice_methodsIcon,
	qna_singleIcon,
	shoeboxesIcon,
	typingIcon,
	practice_per_topicIcon,
	astronautIcon,
	pointer_test_standingIcon,
	video_tutoringIcon,
};

export const getOnboardingTaskImage = (imageName) => onboardingImages[`${imageName}Icon`];

export const bannerImages = {
	extraOptions: extra_optionsIcon,
};

export const filterRecentItemsByLink = (data, type, id) => {
	const filteredItems = data?.recent_items?.filter(
		(item) => !(item?.link?.type === type && item?.link?.id === id),
	);

	return {
		...data,
		recent_items: filteredItems,
	};
};

export const groupRecentItemsByKey = (items, key) => {
	return Object.values(
		items.reduce((acc, item) => {
			const keyVal = item[key];
			if (!acc[keyVal]) {
				acc[keyVal] = {
					title: keyVal.charAt(0).toUpperCase() + keyVal.slice(1),
					results: [],
				};
			}
			acc[keyVal].results.push(item);
			return acc;
		}, {}),
	);
};
